import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { useSystemMetrics } from '@/hooks/useAdminMonitoring';
import { Database } from 'lucide-react';

export function DatabaseMetrics() {
  const { data } = useSystemMetrics();
  // Metrics API returns { system: {...}, database: { size, activeConnections }, timestamp }
  const db = data?.database;

  // The API may return size as a pre-formatted string (e.g. "48 MB") or as a number
  const displaySize = db?.size != null
    ? (typeof db.size === 'string' ? db.size : `${db.size}`)
    : '--';

  return (
    <Card>
      <CardHeader title="PostgreSQL" />
      <CardContent>
        <div className="flex items-center gap-3 mb-3">
          <Database className="h-8 w-8 text-primary-400" />
          <div>
            <p className="text-sm font-medium text-neutral-700 dark:text-neutral-200">Connexions actives</p>
            <p className="text-lg font-bold text-neutral-900 dark:text-neutral-100">{db?.activeConnections ?? '--'}</p>
          </div>
        </div>
        <div className="rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-3">
          <div className="flex justify-between text-xs text-neutral-600 dark:text-neutral-400 mb-1">
            <span>Taille</span><span>{displaySize}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
